export type BatchSearchResultsState = 'idle' | 'loading' | 'error' | 'empty' | 'results'

export function getBatchSearchResultsState(input: {
  hasAppliedFilters: boolean
  isError: boolean
  isFetching: boolean
  hasData: boolean
  itemCount: number
}): BatchSearchResultsState {
  if (!input.hasAppliedFilters) {
    return 'idle'
  }
  if (input.isError) {
    return 'error'
  }
  if (input.isFetching && !input.hasData) {
    return 'loading'
  }
  if (input.itemCount === 0) {
    return 'empty'
  }
  return 'results'
}
